import _ from '@luna/lodash';

export const byteImageCache = {} as Record<string, Promise<string | null>>;

export function addToCache(key: string, variant: string, data: Promise<string | null>): void {
    _.set(byteImageCache, [key, variant], data);
}

export function removeFromCache(key: string): void {
    delete byteImageCache[key];
}

export function getCached(key: string, variant: string): Promise<string | null> | null {
    return _.get(byteImageCache, [key, variant], null);
}
